import React, { useCallback, useRef, useState } from 'react';
import cn from 'classnames';
import ContainerWithShadow from 'components/common/ContainerWithShadow';
import Title from 'components/common/Title';
import { Swiper, SwiperSlide } from 'swiper/react';
import buttons from 'style/buttons.module.scss';
import SwiperCore, { Pagination, Navigation } from 'swiper/core';
import styles from './styles.module.scss';
import { ReactComponent as AvatarPlaceholder } from './avatarPlaceholder.svg';
import 'swiper/swiper.min.css';
import 'swiper/components/pagination/pagination.min.css';
import 'swiper/components/navigation/navigation.min.css';

SwiperCore.use([Pagination, Navigation]);
interface Props {
  avatarUrl: string;
  onChange: (file?: File) => void;
  handleDefaultAvatar: (url: string) => void;
  userType: string;
}

const defaultPicturesMock = [
  {
    id: 0,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar5.jpg',
  },
  {
    id: 1,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar8.jpg',
  },
  {
    id: 2,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar2.jpg',
  },
  {
    id: 3,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar3.jpg',
  },
  {
    id: 4,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar4.jpg',
  },
  {
    id: 5,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar6.jpg',
  },
  {
    id: 6,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar9.jpeg',
  },
  {
    id: 7,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar10.jpeg',
  },
  {
    id: 8,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar11.jpeg',
  },
  {
    id: 12,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar12.jpeg',
  },
  {
    id: 13,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar13.jpeg',
  },
  // {
  //   id: 14,
  //   url:
  //     'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar14.jpeg',
  // },
  {
    id: 15,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar15.jpeg',
  },
  {
    id: 16,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar16.jpeg',
  },
  {
    id: 17,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar17.jpeg',
  },
  {
    id: 18,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar18.jpeg',
  },
  {
    id: 19,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar19.jpeg',
  },
  {
    id: 20,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar20.jpeg',
  },
  {
    id: 21,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar21.jpeg',
  },
  {
    id: 22,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar22.jpeg',
  },
  {
    id: 23,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar23.jpeg',
  },
  {
    id: 24,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar24.jpeg',
  },
  {
    id: 25,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar25.jpeg',
  },
  {
    id: 26,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar26.jpeg',
  },
  {
    id: 27,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar27.jpeg',
  },
  {
    id: 28,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar28.jpeg',
  },
  {
    id: 29,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar29.jpeg',
  },
  {
    id: 30,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar30.jpeg',
  },
  {
    id: 31,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar31.jpeg',
  },
  // {
  //   id: 32,
  //   url:
  //     'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar32.jpeg',
  // },
  {
    id: 33,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar33.jpeg',
  },
  // {
  //   id: 34,
  //   url:
  //     'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar34.jpeg',
  // },
  {
    id: 35,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar35.jpeg',
  },
  {
    id: 36,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar36.jpeg',
  },
  {
    id: 38,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar38.jpeg',
  },
  {
    id: 39,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar39.jpeg',
  },
  {
    id: 40,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar40.jpeg',
  },
  {
    id: 41,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar41.jpeg',
  },
  {
    id: 42,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar42.jpeg',
  },
  {
    id: 43,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar43.jpeg',
  },
  {
    id: 44,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar44.jpeg',
  },
  {
    id: 45,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar45.jpeg',
  },
  {
    id: 46,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar46.jpeg',
  },
  // {
  //   id: 47,
  //   url:
  //     'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar47.jpeg',
  // },
  // {
  //   id: 48,
  //   url:
  //     'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar48.jpeg',
  // },
  // {
  //   id: 49,
  //   url:
  //     'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar49.jpeg',
  // },
  {
    id: 50,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar50.jpeg',
  },
  {
    id: 51,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar51.jpeg',
  },
  {
    id: 52,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar52.jpeg',
  },
  {
    id: 53,
    url:
      'https://anetaedstorageprod.blob.core.windows.net/anetaed-prod-assets/default/default_avatar53.jpeg',
  },
];

const ProfilePhoto: React.FC<Props> = ({
  avatarUrl,
  onChange,
  handleDefaultAvatar,
  userType,
}) => {
  const [avatar, setAvatar] = useState<File>();
  const [localAvatarURL, setLocalAvatarURL] = useState<string>();

  const [avatarRemoved, setAvatarRemoved] = useState<boolean>(false);
  const handleAvatarRemove = useCallback(() => {
    onChange(undefined);
    setAvatarRemoved(false);
    setAvatar(undefined);
    setLocalAvatarURL(undefined);
  }, [onChange]);

  const handleAvatarUpload = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      if (!file) {
        return;
      }
      if (localAvatarURL) {
        URL.revokeObjectURL(localAvatarURL);
      }
      setAvatarRemoved(false);
      setAvatar(file);
      setLocalAvatarURL(URL.createObjectURL(file));
      onChange(file);
    },
    [localAvatarURL, onChange]
  );

  // Required to allow selecting the same file again
  const fileRef = useRef<HTMLInputElement>(null);
  const handleUploadClick = useCallback(() => {
    if (fileRef.current) {
      fileRef.current.value = '';
    }
  }, []);

  const [activeDefault, setActiveDefault] = useState<number>();
  const setDefaultAvatar = useCallback(
    (m: { id: number; url: string }) => {
      setActiveDefault(m.id);
      setLocalAvatarURL(m.url);
      handleDefaultAvatar(m.url);
    },
    [handleDefaultAvatar]
  );

  const title = userType === 'parent' ? 'photo' : 'icon';

  return (
    <div>
      <ContainerWithShadow className={styles.topContainer}>
        <Title variant="h3" className={styles.title}>
          Profile {title}
        </Title>
        <div className={styles.avatarContainer}>
          <div className={styles.avatarPictureContainer}>
            {avatarRemoved || !(localAvatarURL || avatarUrl) ? (
              <AvatarPlaceholder />
            ) : (
              <img
                className={styles.avatar}
                src={localAvatarURL || avatarUrl}
                alt="Avatar"
              />
            )}
          </div>
          <div className={styles.avatarButtons}>
            <input
              className={styles.avatarInput}
              id="avatar-upload"
              type="file"
              ref={fileRef}
              onChange={handleAvatarUpload}
            />
            <label
              onClick={handleUploadClick}
              role="presentation"
              className={cn(
                buttons.buttonOrange,
                styles.avatarButton,
                styles.uploadButton
              )}
              htmlFor="avatar-upload"
            >
              Upload New
            </label>
            {(!!avatar || !!localAvatarURL) && !avatarRemoved && (
              <button
                type="button"
                onClick={handleAvatarRemove}
                className={cn(styles.removeButton, styles.avatarButton)}
              >
                Remove
              </button>
            )}
          </div>
        </div>
      </ContainerWithShadow>
      <div>
        <p className={styles.description}>Select one of these photos</p>
        <div className={styles.defaultPicturesContainer}>
          <Swiper
            slidesPerView={5}
            spaceBetween={30}
            slidesPerGroup={5}
            loop
            loopFillGroupWithBlank
            // pagination={{
            //   clickable: true,
            // }}
            // navigation
          >
            {defaultPicturesMock.map((m) => (
              <SwiperSlide>
                <button
                  key={m.id}
                  className={cn(styles.defaultPicture, {
                    [styles.active]: m.id === activeDefault,
                  })}
                  type="button"
                  onClick={() => setDefaultAvatar(m)}
                >
                  <img
                    className={styles.defaultPictureImage}
                    src={m.url}
                    alt="default"
                  />
                </button>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      <button
        className={cn(buttons.buttomPrimary, styles.submit)}
        type="submit"
      >
        Next
      </button>
    </div>
  );
};

export default ProfilePhoto;
